<template>
  <nav class="steps-bar" :class="[page == 'estimate' ? '' : '-mx-8 xl:-mx-20']">
    <div class="steps-bar-overflow" :class="steps.length > 3 ? 'overflow-auto' : ''">
      <ul
        class="flex justify-between text-current whitespace-nowrap w-max"
        :class="[page == 'estimate' ? '' : '-mx-8 xl:-mx-20']"
      >
        <li v-for="(step, index) in steps" :key="step.index" class="block w-1/2 md:w-auto">
          <button
            type="button"
            class="step-btn w-full h-full cursor-pointer border-b border-transparent text-sm md:text-base duration-300 opacity-20 outline-none select-none"
            :class="value == index ? 'active' : ''"
            :disabled="value == index"
            @click="stepClick(index)"
          >
            <div
              class="flex items-start md:items-center justify-center px-8 md:px-16 py-6 gap-2 md:gap-6 h-full pointer-events-none"
            >
              <span v-if="index >= value" class="min-w-[18px]">{{ index + 1 }}.</span>

              <span v-if="index < value">
                <svg class="w-[18px] h-[14px]">
                  <use xlink:href="#icon-check" />
                </svg>
              </span>

              <span class="text-left w-min sm:w-auto">{{ step.name }}</span>
            </div>
          </button>
        </li>
      </ul>
    </div>

    <div v-if="theme == 'blue'" class="border-b border-blue/10"></div>
    <div v-if="theme=='white'" class="border-b border-white/40"></div>
  </nav>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

export default {
  name: 'stepsBar',
  props: {
    steps: {
      type: Array,
      default: [],
    },
    theme: {
      type: String,
      default: 'blue',
    },
    page: {
      type: String,
      default: '',
    },
    value: 0,
  },

  methods: {
    stepClick(index) {
      this.$emit('input', index)

      gsap
        .timeline()
        .to(window.smoother, {
          scrollTop: window.smoother.offset('#form-wrapp', 'top 100px'),
          duration: 0.4,
        })
        .call(
          () => {
            ScrollTrigger.refresh()
          },
          null,
          ''
        )
    },
  },
}
</script>
